import { Controller } from "@hotwired/stimulus"

// Recarga la página cada pocos segundos mientras el elemento esté en ella. Lo usa la página de una supresión
// RGPD para ir enseñando cada sistema externo según contesta: al terminar, la página ya no lo lleva y deja
// de recargarse.
const INTERVALO_MS = 3000

export default class extends Controller {
  connect() {
    this.temporizador = setTimeout(() => window.location.reload(), INTERVALO_MS)
  }

  disconnect() {
    clearTimeout(this.temporizador)
  }
}
